import { createStructuredSelector } from 'reselect'
import { getCurrentUser } from './currentUserGetters'
import { getLoggedIn } from './sessionGetter'

export default createStructuredSelector({
  loggedIn: getLoggedIn,
  currentUser: getCurrentUser,
  isCurrentUserLoading: state => state.isCurrentUserLoading
})
